import clsx from "clsx";
import PropTypes from "prop-types";
import React from "react";

export function TabNavItem({ id, title, activeTab, setActiveTab }) {
	const isActive = activeTab === id;

	const handleClick = () => {
		setActiveTab(id);
	};

	return (
		<li className={clsx("tab-item", { "is-active": isActive })}>
			<button
				role="tab"
				id={`tab-${id}`}
				aria-selected={isActive}
				aria-controls={`pane-${id}`}
				tabIndex={isActive ? "0" : "-1"}
				className="btn--has-icon btn--search"
				onClick={handleClick}
			>
				<span>{title}</span>
			</button>
		</li>
	);
}

TabNavItem.propTypes = {
	id: PropTypes.string.isRequired,
	title: PropTypes.string.isRequired,
	activeTab: PropTypes.string.isRequired,
	setActiveTab: PropTypes.func.isRequired,
};
